import React from "react";
import styled from "styled-components";
import { FaHandHoldingHeart, FaGift, FaUserEdit } from "react-icons/fa";
import Container from "../Common/Container";

const points = [
  {
    icon: FaHandHoldingHeart({}) as React.ReactElement,
    text: "Handmade Quality",
  },
  { icon: FaGift({}) as React.ReactElement, text: "Unique & Thoughtful Gifts" },
  {
    icon: FaUserEdit({}) as React.ReactElement,
    text: "Personalized Just For You",
  },
];

const Section = styled.section`
  background: #fff;
  padding: 2.5rem 1rem;
  border-radius: 1.5rem;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2.5rem;
`;

const Point = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 180px;
`;

const IconWrap = styled.div`
  font-size: 2.2rem;
  color: #e97d7dff;
  margin-bottom: 0.7rem;
`;

const WhyChoose: React.FC = () => (
  <section>
    <Container>
      <Section>
        <h2
          style={{
            textAlign: "center",
            fontSize: "1.7rem",
            marginBottom: "1.5rem",
          }}
        >
          Why Choose Craft Bin?
        </h2>
        <Grid>
          {points.map((p, i) => (
            <Point key={i}>
              <IconWrap>{p.icon}</IconWrap>
              <div style={{ textAlign: "center", fontWeight: 600 }}>
                {p.text}
              </div>
            </Point>
          ))}
        </Grid>
      </Section>
    </Container>
  </section>
);

export default WhyChoose;
